import {createStore} from 'zustand/vanilla';
import {StoreApi} from 'zustand';

type TicketSelection = {
  ticketId: number;
  name: string;
  quantity: number;
};

type State = {
  eventId: number | null;
  tickets: TicketSelection[];
  setEventId: (eventId: number) => void;
  setTickets: (tickets: TicketSelection[]) => void;
  reset: () => void;
};

export const eventCheckoutStore: StoreApi<State> = createStore<State>((set) => ({
  eventId: null,
  tickets: [],
  setEventId: (eventId) => set({eventId}),
  setTickets: (tickets) => set({tickets}),
  reset: () => set({eventId: null, tickets: []}),
}));
